import React, { useMemo } from "react";
import {
    Dialog,
    DialogClose,
    DialogContent,
    DialogDescription,
    DialogFooter,
    DialogHeader,
    DialogTitle,
} from "../../../components/ui/dialog";
import { useProjectAttachments } from "../../../data/project-attachments";
import { Button } from "../../../components/ui/button";
import { PlusIcon } from "lucide-react";
import { CreateAttachmentDialog } from "./create-attachment-dialog";
import { AttachmentList } from "./attachment-list";

interface Props {
    scope: string[];
    subtitle?: string;
}

export function AttachmentListDialog(props: React.PropsWithChildren<Props>) {
    const allAttachments = useProjectAttachments();
    const att = useMemo(() => {
        return allAttachments.getAttachments(props.scope);
    }, [allAttachments, props.scope]);

    return (
        <Dialog>
            <DialogContent>
                <DialogHeader>
                    <DialogTitle>Attachments</DialogTitle>
                    <DialogDescription>{props.subtitle}</DialogDescription>
                </DialogHeader>
                <AddAttachmentButton target={props.scope} title="Add Task Attachment" />
                <AttachmentList attachments={att} />
                <DialogFooter>
                    <DialogClose>
                        <Button variant={"secondary"}>Close</Button>
                    </DialogClose>
                </DialogFooter>
            </DialogContent>
            {props.children}
        </Dialog>
    );
}

function AddAttachmentButton(props: { target: string[]; title: string }) {
    const [addAttachmentDialogOpen, setAddAttachmentDialogOpen] = React.useState(false);
    return (
        <CreateAttachmentDialog
            target={props.target}
            title={props.title}
            open={addAttachmentDialogOpen}
            onOpenChange={setAddAttachmentDialogOpen}
        >
            <div>
                <Button
                    size={"sm"}
                    className={"self-start"}
                    onClick={() => setAddAttachmentDialogOpen(true)}
                    variant={"outline-primary"}
                >
                    <PlusIcon className={"me-2 h-5 w-5"} /> Add attachment
                </Button>
            </div>
        </CreateAttachmentDialog>
    );
}
